import { Auth } from './../../../autentication/Auth';
import { AutenticationEventType } from './../../../autentication/autentication.event.type';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { ThemeService } from '../../../shared/theme-service/theme.service';

@Component({
	selector: 'app-account-options',
	templateUrl: './account-options.component.html',
	styleUrls: ['./account-options.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class AccountOptionsComponent implements OnInit, OnDestroy {
	primaryColor: any;
	secondaryColor: any;

	rule: string;
	menus: any;

	constructor( private themeService: ThemeService, ) {

		let themeConfigs = this.themeService.getThemeConfigs();
		this.menus = themeConfigs.Menus;
	}

	ngOnInit() {

		this.rule = Auth.getInstance().getUser().rule;

		AppEventDispatcher.listen(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT_MENU, () => {
			this.rule = Auth.getInstance().getUser().rule;
		});

		if (this.themeService.themeConfigs) {
			this.secondaryColor = this.themeService.CorSecundaria ? this.themeService.CorSecundaria : '';
			this.primaryColor = this.themeService.CorPrimaria ? this.themeService.CorPrimaria : '';
		}

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT_MENU);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/account-options/account-options.component.ts